import React, { Component } from 'react';
import Radium from 'radium';
import { any, string } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';
import { isEmpty } from '@widergy/web-utils/lib/array';

import UTBarChart from 'app/components/UTBarChart';
import UTToggle from 'app/components/UTToggle';
import WithErrorWrapper from 'app/components/UTErrorScreen/HOCs/withErrorScreen';
import { chartWidth } from 'constants/sizes';
import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';
import { currencyUnit, consumptionUnit } from 'constants/units';

import BillDetails from './components/BillDetails';
import styles from './styles';

class ConsumptionHistory extends Component {
  constructor(props) {
    super(props);
    const bill =
      this.props.consumptionHistory &&
      this.props.consumptionHistory.bills[this.props.consumptionHistory.bills.length - 1];
    this.state = {
      index: 0,
      key: 1,
      lastBill: bill,
      billDetails: bill && (bill.id ? bill : this.buildBillDetailsInfo(bill, bill.year))
    };
  }

  buildBillDetailsInfo = (bill, year) => ({
    period: bill[`${year}Period`],
    consumption: bill[`${year}Consumption`],
    period_started_on: bill[`${year}StartDate`],
    period_ended_on: bill[`${year}EndDate`],
    issued_on: bill[`${year}IssuedDate`],
    first_expiration_on: bill[`${year}DueDate`],
    amount: bill[`${year}Amount`]
  });

  handleToggleClick = index => this.setState({ index, key: this.state.key + 1 });

  handleDotClick = (payload, year) => {
    this.setState({
      billDetails: year
        ? this.buildBillDetailsInfo(payload, year)
        : this.props.consumptionHistory.bills.find(element => element.id === payload.id)
    });
  };

  toggleOptions = () => [
    {
      label: message('AccountStatus:energy'),
      onClick: this.handleToggleClick,
      show: true,
      unit: consumptionUnit,
      T1: {
        firstKey: 'consumption',
        firstName: message('AccountStatus:consumption'),
        currentYearKey: 'currentConsumption',
        lastYearKey: 'lastConsumption',
        unit: consumptionUnit
      },
      T2: {
        firstKey: 'consumption',
        firstName: message('AccountStatus:consumption'),
        unit: consumptionUnit
      },
      T2P: {
        firstKey: 'consumption_on_peak',
        secondKey: 'consumption_off_peak',
        firstName: message('AccountStatus:consumptionOnPeak'),
        secondName: message('AccountStatus:consumptionOffPeak'),
        unit: consumptionUnit
      },
      T3: {
        firstKey: 'consumption_on_peak',
        secondKey: 'consumption_remainder',
        thirdKey: 'consumption_valley',
        firstName: message('AccountStatus:consumptionOnPeak'),
        secondName: message('AccountStatus:consumptionRemainder'),
        thirdName: message('AccountStatus:consumptionValley'),
        unit: consumptionUnit
      }
    },
    {
      label: message('AccountStatus:billedPower'),
      onClick: this.handleToggleClick,
      show: true,
      unit: 'Kw',
      T2: {
        firstKey: 'billed_power',
        firstName: message('AccountStatus:billedPower'),
        unit: 'Kw'
      },
      T2P: {
        firstKey: 'power_billed_on_peak',
        secondKey: 'power_billed_off_peak',
        firstName: message('AccountStatus:powerBilledOnPeak'),
        secondName: message('AccountStatus:powerBilledOffPeak'),
        unit: 'Kw'
      },
      T3: {
        firstKey: 'power_billed_on_peak',
        secondKey: 'power_billed_off_peak',
        firstName: message('AccountStatus:powerBilledOnPeak'),
        secondName: message('AccountStatus:powerBilledOffPeak'),
        unit: 'Kw'
      }
    },
    {
      label: message('AccountStatus:amount'),
      onClick: this.handleToggleClick,
      show: appConfig.showAmountChart,
      unit: currencyUnit,
      currencyUnit: true,
      T1: {
        firstKey: 'amount',
        firstName: message('AccountStatus:amount'),
        currentYearKey: 'currentAmount',
        lastYearKey: 'lastAmount'
      },
      T2: {
        firstKey: 'amount',
        firstName: message('AccountStatus:amount')
      },
      T2P: {
        firstKey: 'amount',
        firstName: message('AccountStatus:amount')
      },
      T3: {
        firstKey: 'amount',
        firstName: message('AccountStatus:amount')
      }
    }
  ];

  render() {
    const { chartType, consumptionHistory } = this.props;
    const options = this.toggleOptions()
      .filter(option => option.show && !!option[chartType])
      .map((option, i) => ({
        ...option,
        onClick: () => option.onClick(i)
      }));
    const currentOption = options[this.state.index] || options[0];
    const currentOptionConfig = chartType && currentOption[chartType];

    if (consumptionHistory.bills.length === 0)
      return <div style={appConfig.lineSections ? styles.lineContainer : styles.colorContainer} />;

    return (
      <div style={appConfig.lineSections ? styles.lineContainer : styles.colorContainer}>
        <UTLabel large bold>
          {message('AccountStatus:consumptionComparison')}
        </UTLabel>
        {chartType && (
          <div style={styles.data}>
            <div style={styles.chart}>
              <UTToggle style={styles.toggle} options={options} activeIndex={this.state.index} />
              <UTBarChart
                data={consumptionHistory.bills}
                dataKey="period"
                activeValue={this.state.lastBill && this.state.lastBill.month}
                currencyUnit={currentOption.currencyUnit}
                handleClick={this.handleDotClick}
                minWidth={chartWidth}
                years={consumptionHistory.yearsToDisplay}
                unit={currentOption.unit}
                keys={currentOptionConfig}
                key={this.state.key}
              />
            </div>
            <div style={styles.progress}>
              <BillDetails bill={this.state.billDetails} keys={currentOptionConfig} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

ConsumptionHistory.propTypes = {
  consumptionHistory: any, // eslint-disable-line react/forbid-prop-types
  chartType: string
};

export default WithErrorWrapper(
  props => !props.consumptionHistory || isEmpty(props.consumptionHistory.bills)
)(Radium(ConsumptionHistory));
